"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _volumeHigh = _interopRequireDefault(require("cccisd-icons/svg/volume-high"));
var _calculator = _interopRequireDefault(require("cccisd-icons/svg/calculator"));
var _enlarge = _interopRequireDefault(require("cccisd-icons/svg/enlarge"));
var _classnames = _interopRequireDefault(require("classnames"));
var _settings = require("../settings.js");
var _color = _interopRequireDefault(require("color"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HeaderPreview = function HeaderPreview(props) {
  var _props$settings = props.settings,
    showTitle = _props$settings.showTitle,
    showPageTitleDescription = _props$settings.showPageTitleDescription,
    showInstructions = _props$settings.showInstructions,
    showCalculator = _props$settings.showCalculator,
    showAudioToggle = _props$settings.showAudioToggle,
    showFullscreenToggle = _props$settings.showFullscreenToggle,
    title = _props$settings.title,
    pageTitle = _props$settings.pageTitle,
    pageTitleColor = _props$settings.pageTitleColor,
    pageDescription = _props$settings.pageDescription,
    pageDescriptionColor = _props$settings.pageDescriptionColor;
  var showTitleBlock = showTitle || showCalculator || showAudioToggle || showFullscreenToggle;
  var pageDescriptionColorHex = (0, _settings.getTitleColor)(pageDescriptionColor);
  var pageDescriptionColorHexDarken = (0, _color["default"])(pageDescriptionColorHex).darken(0.15).hex();
  var isLightPageDescriptionColor = (0, _color["default"])(pageDescriptionColorHex).luminosity() > 0.5;
  var pageTitleColorHex = (0, _settings.getTitleColor)(pageTitleColor);
  var pageTitleColorHexDarken = (0, _color["default"])(pageTitleColorHex).darken(0.15).hex();
  var isLightPageTitleColor = (0, _color["default"])(pageTitleColorHex).luminosity() > 0.5;
  if (!showTitle && !showPageTitleDescription && !showInstructions && !showCalculator && !showAudioToggle && !showFullscreenToggle) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topBar
  }, showTitleBlock && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].titleBlock
  }, showTitle && /*#__PURE__*/_react["default"].createElement("h2", {
    style: {
      margin: '0'
    },
    className: _style["default"].title
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: title
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonsWrapper
  }, showCalculator && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].audioToggle
  }, /*#__PURE__*/_react["default"].createElement(_calculator["default"], null)), showAudioToggle && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].audioToggle
  }, /*#__PURE__*/_react["default"].createElement(_volumeHigh["default"], null)), showFullscreenToggle && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].audioToggle
  }, /*#__PURE__*/_react["default"].createElement(_enlarge["default"], null)))), (showPageTitleDescription || showInstructions) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].pageBlock
  }, showPageTitleDescription && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].pageTitle, showInstructions && _style["default"].withInstructions),
    style: {
      backgroundColor: pageTitleColorHex,
      borderColor: pageTitleColorHexDarken,
      color: isLightPageTitleColor ? '#333' : '#fff'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: pageTitle
  })), showInstructions && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].pageDescription, showPageTitleDescription && _style["default"].withTitle),
    style: {
      backgroundColor: pageDescriptionColorHex,
      borderColor: pageDescriptionColorHexDarken,
      color: isLightPageDescriptionColor ? '#333' : '#fff'
    }
  }, showInstructions ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: pageDescription
  }) : ''))));
};
HeaderPreview.propTypes = {
  settings: _propTypes["default"].object
};
HeaderPreview.defaultProps = {};
var _default = exports["default"] = HeaderPreview;